


export const assert = function(condition: any, message: string){
  if (!condition)
    throw new Error(message)
}